<template>
  <div id="Service" class="hidden-xs" :class="hideService?'hidden' : ''">
    <div class="service-icon">
      <img src="../assets/images/service.png" alt="">
    </div>
    <div class="service-content">
      <div class="text">您好，我是您的专属售前顾问有什么可以帮您</div>
      <div class="phone-num">400-096-7686</div>
      <img class="close-icon" src="../assets/images/close.png" alt="" @click="hideService = true">
    </div>
  </div>
</template>
<script>
export default {
  name: "Service",
  data() {
    return {
      hideService: false
    };
  },
  methods: {
    
  }
};
</script>
<style scoped>
#Service {
  position: fixed;
  display: flex;
  top: 40%;
  right: -265px; /* 初始位置：完全隐藏在右侧 */
  z-index: 99999;
  transform: translateY(-50%);
  transition: right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1); /* 添加平滑过渡 */
}

#Service:hover {
  right: 0; /* 悬停时：完全显示 */
}
#Service .service-icon{
  position: relative;
  left: 2px;
  height: 110px;
  background: #fff;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  
  /* box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.12); */
  box-shadow: 
    -3px 0 2px -2px rgba(0, 0, 0, 0.08), /* 左边阴影 */
    0 -3px 2px -2px rgba(0, 0, 0, 0.08), /* 上边阴影 */
    0 3px 2px -2px rgba(0, 0, 0, 0.08);  /* 下边阴影 */
}
#Service .service-icon>img{
  position: relative;
  left: 5px;
  top: 20px;
  width: 122px;
  z-index: 9999;
}
#Service .service-content{
  width: 280px;
  height: 110px;
  padding: 20px 25px;
  background: #fff;
  position: relative;
  box-shadow: 0 -3px 2px -2px rgba(0,0,0,0.08), 0 3px 2px -2px rgba(0,0,0,0.08);
  /* box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.12); */
}
.close-icon{
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9999;
  cursor: pointer;
}
.text{
  font-size: 14px;
  line-height: 17px;
}
.phone-num{
  font-size: 27px;
  font-weight: bold;
  background: linear-gradient(90deg, #00A7F7 0%, #006EED 100%);
  background-clip: text;
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Service.vue